import login_bgImg from "./login_bg.png";
import logoImg from "./logo.webp";
import qrCodeFrameImg from "./code_frame.png";

const images = {
  login_bg: login_bgImg,
  logo: logoImg,
  qrCodeFrameImg,
};

export default images;
